  <div class="close-outer">
    <img src="assets/icons/close-x.png" class="close-btn" (click)="closeModal()">
  </div>
  

  <div class="nfo-video-iframe">
    <iframe
        width="100%"
        height="540"
        [src]="videoLink"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    >
    </iframe> -->
</div>
  